// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tOjlH4 {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  align-self: stretch;
}

.ICcNC6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-0-5);
}

.G95X8a {
  align-self: stretch;
}

.Jo2MVs {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-self: stretch;
  gap: var(--spacing-3);
  flex: 1;
  min-height: 0;
}

.zTHAlZ {
  display: flex;
  flex-direction: column;
  overflow: visible;
  align-self: stretch;
  background: var(--surface-neutral-white);
  border-radius: var(--card-border-radius);
  box-shadow: var(--card-box-shadow);
  flex: 1;
  min-height: 0;
}

.KmUkQw {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: var(--spacing-3);
  min-height: 0;
  text-align: left;
  width: 100%;
}

.wVjKLn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 400px;
}

.KmUkQw h3 {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  margin: 0 0 var(--spacing-4) 0;
}

.jiRJbr {
  display: flex;
  gap: var(--spacing-2);
  justify-content: flex-end;
  margin-top: var(--spacing-6);
  width: 100%;
}

.vhiLIr,
.cNb4rI {
  padding: var(--button-padding-md);
  border-radius: var(--button-border-radius);
  border: 1px solid var(--stroke-primary-medium);
  background: var(--surface-primary-medium);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  min-width: 120px;
}

.vhiLIr:hover,
.cNb4rI:hover {
  background: var(--surface-primary-strong);
  transform: translateY(-1px);
  box-shadow: var(--button-box-shadow);
}

.cNb4rI {
  background: var(--surface-neutral-white);
  color: var(--text-primary-medium);
  border-color: var(--stroke-primary-medium);
}

.cNb4rI:hover {
  background: var(--surface-primary-subtle);
}

/* Responsive Design */
@media (max-width: var(--grid-breakpoint-xs)) {
  .tOjlH4 {
    padding: var(--spacing-2);
  }

  .KmUkQw {
    padding: var(--spacing-4);
    max-width: 100%;
  }

  .jiRJbr {
    justify-content: stretch;
    flex-direction: column;
  }

  .vhiLIr,
  .cNb4rI {
    width: 100%;
  }

  .KmUkQw h3 {
    font-size: var(--font-size-lg);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/ChargesCreate/ChargesCreate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,kCAAkC;EAClC,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,0CAA0C;EAC1C,8CAA8C;EAC9C,yCAAyC;EACzC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".container {\n  display: flex;\n  min-height: 100%;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  align-self: stretch;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-0-5);\n}\n\n.breadcrumb {\n  align-self: stretch;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  flex: 1;\n  min-height: 0;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  align-self: stretch;\n  background: var(--surface-neutral-white);\n  border-radius: var(--card-border-radius);\n  box-shadow: var(--card-box-shadow);\n  flex: 1;\n  min-height: 0;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: var(--spacing-3);\n  min-height: 0;\n  text-align: left;\n  width: 100%;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  min-height: 400px;\n}\n\n.stepContent h3 {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  margin: 0 0 var(--spacing-4) 0;\n}\n\n.stepActions {\n  display: flex;\n  gap: var(--spacing-2);\n  justify-content: flex-end;\n  margin-top: var(--spacing-6);\n  width: 100%;\n}\n\n.nextButton,\n.previousButton {\n  padding: var(--button-padding-md);\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--stroke-primary-medium);\n  background: var(--surface-primary-medium);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-width: 120px;\n}\n\n.nextButton:hover,\n.previousButton:hover {\n  background: var(--surface-primary-strong);\n  transform: translateY(-1px);\n  box-shadow: var(--button-box-shadow);\n}\n\n.previousButton {\n  background: var(--surface-neutral-white);\n  color: var(--text-primary-medium);\n  border-color: var(--stroke-primary-medium);\n}\n\n.previousButton:hover {\n  background: var(--surface-primary-subtle);\n}\n\n/* Responsive Design */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .container {\n    padding: var(--spacing-2);\n  }\n\n  .stepContent {\n    padding: var(--spacing-4);\n    max-width: 100%;\n  }\n\n  .stepActions {\n    justify-content: stretch;\n    flex-direction: column;\n  }\n\n  .nextButton,\n  .previousButton {\n    width: 100%;\n  }\n\n  .stepContent h3 {\n    font-size: var(--font-size-lg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tOjlH4`,
	"header": `ICcNC6`,
	"breadcrumb": `G95X8a`,
	"content": `Jo2MVs`,
	"card": `zTHAlZ`,
	"stepContent": `KmUkQw`,
	"loadingContainer": `wVjKLn`,
	"stepActions": `jiRJbr`,
	"nextButton": `vhiLIr`,
	"previousButton": `cNb4rI`
};
module.exports = ___CSS_LOADER_EXPORT___;
